module.exports = __webpack_public_path__ + "media/page-6.a2405fd1.mp3";